import type { FC } from "react";
import { useEffect } from "react";

import { TutoringSelfEvaluation } from "features/SelfEvaluation/Tutoring/_SelfEvaluation";

import type { UserAssignmentDetailFragment } from "api/generated";

import { useAppDispatch } from "store/hooks";
import { resetAssignmentTimer, startAssignmentTimer, stopAssignmentTimer } from "store/slices/timer";
import { useTutoringContext } from "./context/TutoringContext";

interface Props {
  data: UserAssignmentDetailFragment;
  userAssignmentId: string;
  onNextClick: () => void;
}

const Rysovani: FC<Props> = ({ data, userAssignmentId, onNextClick }) => {
  const dispatch = useAppDispatch();
  const { videoTips } = useTutoringContext();

  useEffect(() => {
    dispatch(resetAssignmentTimer());
    dispatch(startAssignmentTimer());

    return () => {
      dispatch(resetAssignmentTimer());
    };
  }, []);

  const handleNextClick = () => {
    dispatch(stopAssignmentTimer());
    onNextClick();
  };

  return (
    <>
      <TutoringSelfEvaluation
        userAssignment={data}
        userAssignmentId={data.id}
        onNextClick={handleNextClick}
        videoTips={videoTips}
      />
    </>
  );
};

export default Rysovani;
